export default __webpack_public_path__ + "static/doki-0d80cb0a9a9cf8a6aaba2869beb6a186.png";